import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '@shared/services/authentication.service';
import { PasswordRegExp } from '@shared/utils';
import { confirmPasswordValidator } from '@shared/validators/confirmPassword.validator';
import { Subject, catchError, of, switchMap, takeUntil, tap } from 'rxjs';

@Component({
  selector: 'app-new-password',
  templateUrl: './new-password.component.html',
  styleUrl: './new-password.component.scss'
})
export class NewPasswordComponent implements OnInit, OnDestroy {
  form = this._formBuilder.group(
    {
      password: ['', [Validators.required, Validators.pattern(PasswordRegExp)]],
      confirmPassword: ['', [Validators.required, Validators.pattern(PasswordRegExp)]]
    },
    { validators: confirmPasswordValidator }
  );
  ngUnsubscribe: Subject<any> = new Subject<any>();
  mode = '';
  actionCode = ''; // Firebase code used to prove that this is a real password reset.
  actionCodeChecked = false;
  isReady = false;

  get passwordFormField() {
    return this.form.get('password');
  }

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _authenticationService: AuthenticationService,
    private _formBuilder: FormBuilder
  ) {}

  ngOnInit() {
    this._activatedRoute.queryParams
      .pipe(
        takeUntil(this.ngUnsubscribe),
        switchMap((params) => {
          if (!params) throw new Error('missing query parameters');
          this.actionCode = params['oobCode'];
          this.mode = params['mode'];
          if (this.mode !== 'resetPassword') throw new Error('mode not implemented yet');
          return this._authenticationService.verifyPasswordResetCode(this.actionCode);
        }),
        tap((email) => {
          if (email) {
            this.actionCodeChecked = true;
            this.isReady = true;
          } else {
            throw new Error('verifyPasswordResetCode failed');
          }
        }),
        catchError(() => {
          this._router.navigate(['/login']);
          return of(null);
        })
      )
      .subscribe();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next('');
    this.ngUnsubscribe.complete();
  }

  getYear() {
    return new Date().getFullYear();
  }

  /**
   * Attempt to confirm the password reset with firebase and
   * navigate user back to login.
   */
  handleResetPassword() {
    if (!this.form.value.password) return;
    // Save the new password.
    this._authenticationService
      .confirmPasswordReset(this.actionCode, this.form.value.password)
      .pipe(
        tap({
          next: () => {
            // this.logger.debug(LOG_PREFIX + 'New password has been saved')
            this._router.navigate(['/login']);
          },
          error: () => {
            // this.logger.error(LOG_PREFIX + 'all$ error', err)
          }
        })
      )
      .subscribe();
  }
}
